/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svchip_Headless_BrowserInputs */

const en_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Headless browser`)
};

const ar_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`متصفح بلا واجهة`)
};

const bn_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`হেডলেস ব্রাউজার`)
};

const de_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kopfloser Browser`)
};

const es_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegador sin cabeza`)
};

const fr_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navigateur sans tête`)
};

const pt_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Navegador sem cabeça`)
};

const zh_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`无头浏览器`)
};

const tr_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başsız tarayıcı`)
};

const ru_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Безголовый браузер`)
};

const pl_svchip_headless_browser = /** @type {(inputs: Svchip_Headless_BrowserInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Przeglądarka bezgłowa`)
};

/**
* | output |
* | --- |
* | "Headless browser" |
*
* @param {Svchip_Headless_BrowserInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svchip_headless_browser = /** @type {((inputs?: Svchip_Headless_BrowserInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svchip_Headless_BrowserInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svchip_headless_browser(inputs)
	if (locale === "bn") return bn_svchip_headless_browser(inputs)
	if (locale === "de") return de_svchip_headless_browser(inputs)
	if (locale === "es") return es_svchip_headless_browser(inputs)
	if (locale === "fr") return fr_svchip_headless_browser(inputs)
	if (locale === "pt") return pt_svchip_headless_browser(inputs)
	if (locale === "zh") return zh_svchip_headless_browser(inputs)
	if (locale === "tr") return tr_svchip_headless_browser(inputs)
	if (locale === "ru") return ru_svchip_headless_browser(inputs)
	if (locale === "pl") return pl_svchip_headless_browser(inputs)
	return en_svchip_headless_browser(inputs)
});